import apiService, { buildQueryString } from './api';
class OrdensServicoService {
    // Listar ordens de serviço
    async list(filters = {}) {
        const queryString = buildQueryString(filters);
        const apiResponse = await apiService.get(`/ordens-servico${queryString}`);
        // Mapear a resposta da API para o formato esperado
        return {
            ordensServico: apiResponse.data || [],
            pagination: {
                currentPage: apiResponse.pagination?.page || 1,
                totalPages: apiResponse.pagination?.totalPages || 1,
                totalItems: apiResponse.pagination?.total || 0, // Mapear 'total' para 'totalItems'
                itemsPerPage: apiResponse.pagination?.limit || 25,
                hasNext: apiResponse.pagination?.hasNext || false,
                hasPrev: apiResponse.pagination?.hasPrev || false
            }
        };
    }
    // Buscar ordem de serviço por ID
    async getById(id) {
        const response = await apiService.get(`/ordens-servico/${id}`);
        return response.data;
    }
    // Criar ordem de serviço
    async create(data) {
        const response = await apiService.post('/ordens-servico', data);
        return response.data;
    }
    // Atualizar ordem de serviço
    async update(id, data) {
        const response = await apiService.put(`/ordens-servico/${id}`, data);
        return response.data;
    }
    // Alterar estado da ordem de serviço
    async changeState(id, novoEstadoId, observacoes) {
        const response = await apiService.post(`/ordens-servico/${id}/change-state`, {
            novoEstadoId,
            observacoes
        });
        return response.data;
    }
    // Aprovar orçamento
    async approveOrcamento(id) {
        const response = await apiService.post(`/ordens-servico/${id}/approve-orcamento`);
        return response.data;
    }
    // Atualizar valor final do orçamento
    async updateValorFinal(id, valorFinal) {
        const response = await apiService.put(`/ordens-servico/${id}/valor-final`, {
            valorFinal
        });
        return response.data;
    }
    // Fechar ordem de serviço
    async fecharOS(id, data) {
        const response = await apiService.post(`/ordens-servico/${id}/fechar`, data);
        return response.data;
    }
    // Obter estatísticas
    async getStats() {
        const response = await apiService.get('/ordens-servico/stats');
        return response.data;
    }
    // Buscar estados de OS
    async getEstados() {
        const response = await apiService.get('/configuracoes/estados-os');
        return response.data;
    }
    // Exportar ordens de serviço
    async exportar(format, filters = {}) {
        const queryString = buildQueryString({ ...filters, format });
        await apiService.download(`/ordens-servico/export${queryString}`, `ordens-servico.${format}`);
    }
    // Gerar relatório de ordem de serviço
    async gerarRelatorio(id, tipo) {
        // Abrir o PDF diretamente em nova aba
        const pdfUrl = `http://localhost:4050/api/ordens-servico/${id}/pdf/${tipo}`;
        window.open(pdfUrl, '_blank');
    }
    // Buscar ordens por técnico
    async getByTecnico(tecnicoId) {
        const response = await apiService.get(`/ordens-servico?usuarioResponsavelId=${tecnicoId}&limit=100`);
        return response.data.ordensServico;
    }
    // Buscar ordens por cliente
    async getByCliente(clienteId) {
        const response = await apiService.get(`/ordens-servico?clienteId=${clienteId}&limit=100`);
        return response.data.ordensServico;
    }
    // Buscar ordens por equipamento
    async getByEquipamento(equipamentoId) {
        const response = await apiService.get(`/ordens-servico?equipamentoId=${equipamentoId}&limit=100`);
        return response.data.ordensServico;
    }
    // Dashboard do técnico
    async getDashboardTecnico(tecnicoId) {
        const response = await apiService.get(`/ordens-servico/dashboard/tecnico/${tecnicoId}`);
        return response.data;
    }
}
// Instância singleton
const ordensServicoService = new OrdensServicoService();
export default ordensServicoService;
// Utilitários
export const prioridades = [
    { value: 'BAIXA', label: 'Baixa', color: 'green' },
    { value: 'NORMAL', label: 'Normal', color: 'blue' },
    { value: 'ALTA', label: 'Alta', color: 'yellow' },
    { value: 'URGENTE', label: 'Urgente', color: 'red' }
];
export const getPrioridadeConfig = (prioridade) => {
    return prioridades.find(p => p.value === prioridade) || prioridades[1];
};
export const formatPrioridade = (prioridade) => {
    const config = getPrioridadeConfig(prioridade);
    return config.label;
};
export const getPrioridadeColor = (prioridade) => {
    const config = getPrioridadeConfig(prioridade);
    return config.color;
};
export const formatValor = (valor) => {
    return new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: 'EUR'
    }).format(valor);
};
export const calcularIVA = (valor, percentual = 23) => {
    return (valor * percentual) / 100;
};
export const calcularTotalComIVA = (valor, percentual = 23) => {
    return valor + calcularIVA(valor, percentual);
};
